import { render, staticRenderFns } from "./AudiencesTable.vue?vue&type=template&id=dea3399e&scoped=true"
import script from "./AudiencesTable.vue?vue&type=script&lang=js"
export * from "./AudiencesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea3399e",
  null
  
)

export default component.exports